var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['group-title-container', `group-title-container-${_vm.align}`]},[_c('div',{class:['sub-title', { 'sub-title-second': _vm.reverse }]},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")]),_c('div',{class:[
      'main-title',
      { 'main-title-light': _vm.light },
      { 'main-title-first': _vm.reverse }
    ]},_vm._l((_vm.mainTitle),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }